/* 4Women Cyber (29/09/2026): los relojes y el gancho de regalo.
 *
 * Vive en un asset y no inline por lo mismo que fw-packs.js: el quick-add de
 * coleccion inyecta fichas por morph y un <script> que llega asi no corre.
 * Todo delega sobre document, asi que una carga alcanza.
 *
 * ============================================================
 * 1. RELOJES
 * ============================================================
 *
 * Liquid pinta el primer estado (snippets/fw-cyber-reloj.liquid) y aqui se
 * corrige cada segundo con la hora del navegador. Las paginas se sirven
 * cacheadas, asi que el numero de Liquid puede venir atrasado: el que manda es
 * este. Al llegar a cero el reloj se esconde, y con el cualquier contenedor
 * marcado con `data-fw-cyber-fin-oculta`.
 *
 * ============================================================
 * 2. GANCHO DE REGALO
 * ============================================================
 *
 * Pedido de Gabriel: el gancho "se va a agregar solo al carrito". Shopify no
 * agrega regalos por si mismo (un BxGy automatico exige que el producto YA
 * este en el carrito), asi que lo hace este script:
 *
 *   - total del carrito (con descuentos, sin el regalo) >= umbral y hay algo
 *     mas que el regalo  ->  queda exactamente 1 gancho
 *   - si no                ->  se saca
 *
 * Se revisa al cargar la pagina y despues de cada `cart:update`, que es el
 * evento que el tema emite al agregar, cambiar o quitar. Sacarlo cuando el
 * carrito baja del umbral no es opcional: sin eso basta con llenar el
 * carrito, recibir el gancho y vaciarlo para llevarselo gratis.
 *
 * RED DE SEGURIDAD: solo actua si la variante del regalo vale $0 y esta
 * disponible (lo decide snippets/fw-cyber-cfg.liquid). Un producto con
 * precio nunca entra solo al carrito.
 *
 * Al cambiar el carrito se emite `cart:update` para que el cajon y la burbuja
 * se repinten. Ese evento ABRE el cajon si tiene `auto-open` (ver la
 * correccion del 09/09 en fw-abrigo-quickadd.js), asi que se le quita el
 * atributo mientras se emite: agregar el regalo no puede interrumpir a la
 * clienta. Nuestro propio evento lleva `sourceId: 'fw-cyber-regalo'` y el
 * oyente lo ignora, asi que no hay vueltas en circulo.
 */
(() => {
  if (window.__fwCyber) return;
  window.__fwCyber = true;

  /* ---------- 1. Relojes ---------- */

  const dos = (n) => String(n).padStart(2, '0');

  const tic = () => {
    const ahora = Date.now() / 1000;
    document.querySelectorAll('fw-cyber-reloj').forEach((el) => {
      const fin = Number(el.dataset.fin) || 0;
      const ini = Number(el.dataset.inicio) || 0;
      if (!fin) return;

      let hasta = fin;
      let antes = false;
      if (ini && ahora < ini) {
        hasta = ini;
        antes = true;
      }

      const resta = Math.max(0, Math.floor(hasta - ahora));
      if (!antes && resta <= 0) {
        el.hidden = true;
        const caja = el.closest('[data-fw-cyber-fin-oculta]');
        if (caja) caja.hidden = true;
        return;
      }
      el.hidden = false;

      const et = el.querySelector('[data-fw-crj-et]');
      const txt = antes ? 'Empieza en' : el.dataset.etFin || 'Termina en';
      if (et && et.textContent !== txt) et.textContent = txt;

      const v = {
        d: Math.floor(resta / 86400),
        h: Math.floor((resta % 86400) / 3600),
        m: Math.floor((resta % 3600) / 60),
        s: resta % 60,
      };
      el.querySelectorAll('[data-u]').forEach((b) => {
        const t = dos(v[b.dataset.u]);
        if (b.textContent !== t) b.textContent = t;
      });
    });
  };

  tic();
  setInterval(tic, 1000);

  /* ---------- 2. Gancho de regalo ---------- */

  let cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('fw-cyber-cfg').textContent);
  } catch (e) {
    cfg = {};
  }

  const activo = cfg.regalo && cfg.precio === 0 && cfg.disponible === true && cfg.umbral > 0;
  if (!activo) return;

  let ocupado = false;
  let pendiente = false;

  const avisar = (cuantos) => {
    const cajon = document.querySelector('cart-drawer-component[auto-open]');
    if (cajon) cajon.removeAttribute('auto-open');
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'fw-cyber-regalo', data: { itemCount: cuantos, source: 'fw-cyber-regalo' } },
      })
    );
    if (cajon) cajon.setAttribute('auto-open', '');
  };

  const post = (ruta, cuerpo) =>
    fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    });

  const revisar = async () => {
    if (ocupado) {
      pendiente = true;
      return;
    }
    ocupado = true;
    try {
      const carrito = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const lineas = carrito.items || [];
      const regalos = lineas.filter((i) => i.variant_id === cfg.regalo);
      const tiene = regalos.reduce((n, i) => n + i.quantity, 0);
      const base = carrito.total_price - regalos.reduce((n, i) => n + i.final_line_price, 0);
      const otras = lineas.length - regalos.length;
      const corresponde = otras > 0 && base >= cfg.umbral;

      let cambio = false;
      if (corresponde && tiene === 0) {
        const r = await post('/cart/add.js', {
          items: [{ id: cfg.regalo, quantity: 1, properties: { _regalo: 'cyber' } }],
        });
        cambio = r.ok;
      } else if (corresponde && tiene > 1) {
        const upd = {};
        regalos.forEach((i, n) => {
          upd[i.key] = n === 0 ? 1 : 0;
        });
        cambio = (await post('/cart/update.js', { updates: upd })).ok;
      } else if (!corresponde && tiene > 0) {
        const upd = {};
        regalos.forEach((i) => {
          upd[i.key] = 0;
        });
        cambio = (await post('/cart/update.js', { updates: upd })).ok;
      }

      if (cambio) {
        const nuevo = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        if (typeof nuevo.item_count === 'number') avisar(nuevo.item_count);
      }
    } catch (e) {
      /* Sin red o con el limite de tasa: se reintenta en el proximo cambio del
         carrito. Un regalo que tarda un paso en aparecer es mejor que un
         error en pantalla. */
    } finally {
      ocupado = false;
      if (pendiente) {
        pendiente = false;
        setTimeout(revisar, 300);
      }
    }
  };

  document.addEventListener('cart:update', (ev) => {
    /* Nuestro propio aviso no necesita otra vuelta: el carrito ya quedo bien. */
    if (ev.detail && ev.detail.sourceId === 'fw-cyber-regalo') return;
    setTimeout(revisar, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revisar);
  } else {
    revisar();
  }
})();
